import z from "zod";

export const projectListDataSchema = z.object({
  /** Which kind the list holds; left out, it holds every project. */
  type: z
    .enum(["subscription", "intervention", "all"])
    .optional()
    .transform((value) => value ?? "all"),
});

export type ProjectListDataProps = z.infer<typeof projectListDataSchema>;
